/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Status_ListeningInputs */



/**
* | output |
* | --- |
* | "Listening…" |
*
* @param {Practice_Session_Status_ListeningInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_status_listening = /** @type {((inputs?: Practice_Session_Status_ListeningInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Status_ListeningInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Luisteren…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("À l'écoute…")
	return /** @type {LocalizedString} */ ("Listening…")
});